module.exports = __webpack_public_path__ + "static/media/total_logo_circle.1fb0fd29.png";